import Vue from 'vue';
import invert from 'invert-color';

Vue.prototype.$invertColor = (color) => invert(color || '#3490dc', { black: '#212529', white: '#fff', threshold: 0.3 });
